import React from 'react';
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CButton,
  CNav,
  CNavLink,
  CNavItem,
  CTabContent,
  CTabPane,
  CCard,
  CCardBody,
  CDateRangePicker,
  CSpinner,
  CFormSelect,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import {cilX} from '@coreui/icons';
import styles from './CashBids.module.css';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
  hideCashBidModal,
  fetchCashBidLocationNearByHistory,
  userSelectedCashBidLocationNearByHistoricalCommodity,
  userSelectedCashBidLocationNearByHistoricalStartDate,
  userSelectedCashBidLocationNearByHistoricalEndDate,
  showPurchaseContractModal,
} from './cashBids-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

// Highcharts plugin for adding better XLS and XLSX support through the third
// party zipcelx library.
// Code taken from online Highcharts support forums
// Import of 3rd party library in index.html of public folder
(function (H) {
  if (window.zipcelx && H.getOptions().exporting) {
    H.Chart.prototype.downloadXLSX = function () {
      var div = document.createElement('div'),
        name,
        xlsxRows = [],
        rows;
      div.style.display = 'none';
      document.body.appendChild(div);
      rows = this.getDataRows(true);
      xlsxRows = rows.slice(1).map(function (row) {
        return row.map(function (column) {
          return {
            type: typeof column === 'number' ? 'number' : 'string',
            value: column,
          };
        });
      });
      if (this.options.exporting.filename) {
        name = this.options.exporting.filename;
      }
      else if (this.title && this.title.textStr) {
        name = this.title.textStr.replace(/ /g, '-').toLowerCase();
      }
      else {
        name = 'chart';
      }
      window.zipcelx({
        filename: name,
        sheet: {
          data: xlsxRows
        }
      });
    };
    H.getOptions().lang.downloadXLSX = 'Download XLSX';
    H.getOptions().exporting.menuItemDefinitions.downloadXLSX = {
      textKey: 'downloadXLSX',
      onclick: function () {
        this.downloadXLSX();
      }
    };
    var menuItems = H.getOptions().exporting.buttons.contextButton.menuItems;
    menuItems[menuItems.indexOf('downloadXLS')] = 'downloadXLSX';

    // NOTRS Code Fragment - Remove unwanted export types from menu
    if (menuItems.length > 3) {
      menuItems.splice(1, 7);
      menuItems.splice(3, 1);
    }
  }
}(Highcharts));

const CashBidsModal = () => {

  const dispatch = useDispatch();

  const {
    selectedLocation,
    cashBidsModalIsVisible,
    fetchingCashBidLocationNearByHistory,
    historicalNearByCommoditiesDropDownListDataSource,
    historicalNearByStartDate,
    historicalNearByEndDate,
    historicalNearByCommodity,
    cashBidLocationNearByHistory,
  } = useSelector(state => state.cashBids);

  const [activeTabIndex, setActiveTabIndex] = React.useState(0);

  return (
    <CModal
      fullscreen
      alignment='center'
      scrollable 
      visible={cashBidsModalIsVisible}>
      <CModalHeader closeButton={false}>
        <CModalTitle className={styles.cashBidsModalTitle}>{selectedLocation.locationName}</CModalTitle>
        <CButton className={styles.modalCloseButton} onClick={() => dispatch(hideCashBidModal())}>
          <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
        </CButton>
      </CModalHeader>
      <CModalBody className={styles.cashBidsModalBody}>
        <CNav variant='pills' role='tablist' layout='fill'>
          <CNavItem>
            <CNavLink
              href='#!'
              active={activeTabIndex === 0}
              onClick={(event) => {
                event.preventDefault();
                setActiveTabIndex(0);
              }}>
              Current
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              href='#!'
              active={activeTabIndex === 1}
              onClick={(event) => {
                event.preventDefault();
                setActiveTabIndex(1);
              }}>
              Historical Near Bys
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          <CTabPane role='tabpanel' visible={activeTabIndex === 0}>
          {
            selectedLocation.bids !== undefined ?
              selectedLocation.bids.map((bid, index) => (
                <div key={index}>
                  <div className={styles.cbModalCommodity}>
                    {bid.commodity}
                  </div>
                  <CTable className={styles.cashBidsTable}>
                    <CTableHead className={styles.cbTableHead}>
                      <CTableRow>
                        <CTableHeaderCell>Del. Start</CTableHeaderCell>
                        <CTableHeaderCell>Del. End</CTableHeaderCell>
                        <CTableHeaderCell>Basis Month</CTableHeaderCell>
                        <CTableHeaderCell>Futures Price</CTableHeaderCell>
                        <CTableHeaderCell>Basis</CTableHeaderCell>
                        <CTableHeaderCell>Cash Price</CTableHeaderCell>
                        <CTableHeaderCell>Fut. Chg.</CTableHeaderCell>
                        {
                            selectedLocation.company === 'Premier Cooperative - IL' ? (
                              <CTableHeaderCell></CTableHeaderCell>
                            ) : null
                        }
                        {
                            selectedLocation.company === 'Premier Cooperative - IL' ? (
                              <CTableHeaderCell></CTableHeaderCell>
                            ) : null
                        }
                      </CTableRow>
                    </CTableHead>
                    <CTableBody className={styles.cbTableBody}>
                    {
                      bid.bids.map((cashBid, index) => (
                        <CTableRow key={'bid' + index} className={styles.cbTableRow}>
                          <CTableDataCell>{new Date(cashBid.delivery_start).toLocaleDateString()}</CTableDataCell>
                          <CTableDataCell>{new Date(cashBid.delivery_end).toLocaleDateString()}</CTableDataCell>
                          <CTableDataCell>{cashBid.basismonth}</CTableDataCell>
                          <CTableDataCell>{cashBid.futures.lastPrice}</CTableDataCell>
                          <CTableDataCell>{cashBid.basis / 100}</CTableDataCell>
                          <CTableDataCell>${cashBid.cashprice}</CTableDataCell>
                          <CTableDataCell>{cashBid.futures.netChange}</CTableDataCell>
                          {
                            selectedLocation.company === 'Premier Cooperative - IL' ? (
                              <CTableDataCell>
                                <button 
                                  className={styles.sellGrainButton}
                                  onClick={(e) => {
                                    dispatch(showPurchaseContractModal(cashBid, selectedLocation, cashBid.futures, false));
                                    e.stopPropagation();
                                  }}>
                                  Sell Grain
                                </button>
                              </CTableDataCell>
                            ) : null
                          }
                          {
                            selectedLocation.company === 'Premier Cooperative - IL' ? (
                              <CTableDataCell>
                                <button 
                                  className={styles.makeOfferButton}
                                  onClick={(e) => {
                                    dispatch(showPurchaseContractModal(cashBid, selectedLocation, cashBid.futures, true));
                                    e.stopPropagation();
                                  }}>
                                  Make Offer
                                </button>
                              </CTableDataCell>
                            ) : null
                          }
                        </CTableRow>
                      ))
                    }
                    </CTableBody>
                  </CTable>
                </div>
              )
            ) : null
          }
          </CTabPane>
          <CTabPane role='tabpanel' visible={activeTabIndex === 1}>
            <br />
            <div className={styles.rowFlexDiv}>
              <CCard className={styles.historicalCard}>
                <CCardBody>
                  <div className={styles.rowFlexDiv}>
                    <CFormSelect
                      className='mb-3'
                      style={{width: 200, height: 38,}}
                      value={JSON.stringify(historicalNearByCommodity)}
                      options={historicalNearByCommoditiesDropDownListDataSource}
                      onChange={e => dispatch(userSelectedCashBidLocationNearByHistoricalCommodity(e.target.value))} />
                    <CDateRangePicker
                      locale='en-US'
                      style={{height: 58,}}
                      startDate={historicalNearByStartDate}
                      endDate={historicalNearByEndDate}
                      onStartDateChange={(date) => dispatch(userSelectedCashBidLocationNearByHistoricalStartDate(date))}
                      onEndDateChange={(date) => dispatch(userSelectedCashBidLocationNearByHistoricalEndDate(date))} />
                    <CButton
                      color='primary'
                      variant='outline'
                      style={{width: 200, height: 38,}}
                      onClick={() => dispatch(fetchCashBidLocationNearByHistory())}
                      disabled={fetchingCashBidLocationNearByHistory}>
                      {
                        fetchingCashBidLocationNearByHistory === true ? (
                          <CSpinner size='sm' />
                        ) : null
                      }
                      {fetchingCashBidLocationNearByHistory === true ? ' Loading' : 'Load Historical Data'}
                    </CButton>
                  </div>
                  <br />
                  <div>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={{
                        chart: {
                          type: 'line',
                        },
                        title: {
                          text: 'Historical Near By Data',
                        },
                        exporting: {
                          enabled: true,
                          buttons: {
                            contextButton: {
                              text: 'Download Data',
                            },
                          },
                        },
                        xAxis: {
                          categories: cashBidLocationNearByHistory !== null ? cashBidLocationNearByHistory.cashPriceObservationDateTimeFormatted : [],
                          type: 'category',
                          tickInterval: 1,
                        },
                        yAxis: [
                          {
                            title: {
                              text: 'Cash Price',
                              style: {
                                color: Highcharts.getOptions().colors[0]
                              }
                            },
                            labels: {
                              format: '{value}',
                              style: {
                                color: Highcharts.getOptions().colors[0]
                              }
                            },
                            opposite: false
                          },
                          {
                            title: {
                              text: 'Basis',
                              style: {
                                color: Highcharts.getOptions().colors[1]
                              }
                            },
                            labels: {
                              format: '{value}',
                              style: {
                                color: Highcharts.getOptions().colors[1]
                              }
                            },
                            opposite: true
                          },
                        ],
                        plotOptions: {
                          line: {
                            dataLabels: {
                              enabled: false
                            },
                            enableMouseTracking: true
                          },
                          series: {
                            events: {
                              legendItemClick: (chartContext, event) => {
                                const seriesIndex = chartContext.target.index;
                                const chart = chartContext.target.chart;
                                chart.series.forEach((series, index) => {
                                  if (index === seriesIndex) {
                                    series.setVisible(true, false);
                                    series.setVisible();
                                  } 
                                  else {
                                    series.setVisible(false, false);
                                  }
                                });
                                chart.redraw();
                              },
                            },
                          },
                        },
                        series: [
                          {
                            name: 'Cash Price',
                            data: cashBidLocationNearByHistory !== null ? cashBidLocationNearByHistory.cashPrices : [],
                            yAxis: 0,
                            tooltip: {
                              valueSuffix: ''
                            },
                          },
                          {
                            name: 'Basis',
                            data: cashBidLocationNearByHistory !== null ? cashBidLocationNearByHistory.basisValues : [],
                            yAxis: 1,
                            tooltip: {
                              valueSuffix: ''
                            },
                            visible: false,
                          }
                        ]
                      }} />
                  </div>
                </CCardBody>
              </CCard>
            </div>
          </CTabPane>
        </CTabContent>
      </CModalBody>
    </CModal>
  );
}

export default CashBidsModal;